const CREATION_THRESHOLD = 1000 * 3600 * 12; // 12 hours

export const isReturningClient = (client) => {
  if (!client || !client.created_at) {
    return false;
  }
  const timeSince = Date.now() - new Date(client.created_at).getTime();
  if (timeSince > CREATION_THRESHOLD) {
    return true;
  }
  return false;
};

export const bannedPhoneNumbers = () => {
  return ['9168268707', '9163801918', '7066911986', '7606850861', '7142484373', '9168031025', '9162614133', '9166281128', '9162891685'];
};

export const bannedEmails = () => {
  return ['destinymberches@gmail.com', 'josephgriffin23@yahoo.com', 'aundrea.kr247@gmail.com', 'deluxehomes714@gmail.com', 'thestickyestfingers@gmail.com', 'wonderwoman0317@gmail.com', 'dboydtanner@gmail.com'];
};
